import { Plugin, PluginKey } from 'prosemirror-state';
import { isInTable, TableMap } from 'prosemirror-tables';
var key = new PluginKey('tableCellSelfResizing');
var tableCellSelfResizing = function () {
    return new Plugin({
        key: key,
        appendTransaction: function (trs, oldState, state) {
            var tr = state.tr, selection = state.selection;
            try {
                // It is judged that the block card is added to the table
                if (oldState.doc.nodeSize < state.doc.nodeSize && isInTable(oldState) && isInTable(state)) {
                    var width_1 = 0;
                    trs.some(function (item) {
                        var steps = item.steps;
                        if (steps.length) {
                            return steps.some(function (step) {
                                // @ts-ignore
                                var slice = step.slice;
                                var content = slice.content;
                                return content.content.some(function (val) {
                                    if (val.isBlock && val.type !== state.schema.nodes.paragraph && val.attrs.width) {
                                        width_1 = val.attrs.width;
                                        return true;
                                    }
                                });
                            });
                        }
                        return false;
                    });
                    if (width_1) {
                        var $anchor = selection.$anchor;
                        var depth = $anchor.depth;
                        var cell = $anchor.pos;
                        var $tableCell = state.doc.resolve(cell).node(3);
                        var currentWidth = $tableCell.attrs.colwidth.reduce(function (res, cur) {
                            if (res > cur)
                                return res;
                            return cur;
                        });
                        while (depth > 1) {
                            var $current = state.doc.resolve(cell).node();
                            if ($current.type === state.schema.nodes.table_row) {
                                break;
                            }
                            cell = state.doc.resolve(cell).before();
                            depth = state.doc.resolve(cell).depth;
                        }
                        if (currentWidth < width_1) {
                            var $cell = state.doc.resolve(cell);
                            var table = $cell.node(-1), map = TableMap.get(table), start = $cell.start(-1);
                            if (!$cell || !$cell.nodeAfter)
                                return;
                            var col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
                            for (var row = 0; row < map.height; row++) {
                                var mapIndex = row * map.width + col;
                                if (row && map.map[mapIndex] === map.map[mapIndex - map.width])
                                    continue;
                                var pos = map.map[mapIndex];
                                var node = table.nodeAt(pos);
                                if (!node)
                                    continue;
                                var attrs = node.attrs;
                                var index = attrs.colspan === 1 ? 0 : col - map.colCount(pos);
                                if (attrs.colwidth && attrs.colwidth[index] === width_1)
                                    continue;
                                var colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
                                colwidth[index] = width_1;
                                tr.setNodeMarkup(start + pos, undefined, setAttr(attrs, 'colwidth', colwidth));
                            }
                            return tr;
                        }
                    }
                }
            }
            catch (e) {
                console.error('cell-self-resizing error:', e);
            }
        },
    });
};
var zeroes = function (n) {
    var result = [];
    for (var i = 0; i < n; i++)
        result.push(0);
    return result;
};
var setAttr = function (attrs, name, value) {
    var result = {};
    for (var prop in attrs)
        result[prop] = attrs[prop];
    result[name] = value;
    return result;
};
export { key, tableCellSelfResizing };
//# sourceMappingURL=cell-self-resizing.js.map